module.exports = __webpack_public_path__ + "img/5.717dc992.jpg";